/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EfectoSecundarioModelDto } from '../../models/efecto-secundario-model-dto';

export interface FarmacosControllerGetEfectosSecundarios$Params {
}

export function farmacosControllerGetEfectosSecundarios(http: HttpClient, rootUrl: string, params?: FarmacosControllerGetEfectosSecundarios$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EfectoSecundarioModelDto>>> {
  const rb = new RequestBuilder(rootUrl, farmacosControllerGetEfectosSecundarios.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<EfectoSecundarioModelDto>>;
    })
  );
}

farmacosControllerGetEfectosSecundarios.PATH = '/api/farmacos/efectos-secundarios';
